import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserLessonsByUserIdAndCourseId: build.query<
      GetUserLessonsByUserIdAndCourseIdApiResponse,
      GetUserLessonsByUserIdAndCourseIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/users/${queryArg.id}/user-courses/${queryArg.courseId}/user-lessons`,
        params: { page: queryArg.page, size: queryArg.size },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type GetUserLessonsByUserIdAndCourseIdApiResponse =
  /** status 200 OK */ BackOfficeUserLessonPage;
export type GetUserLessonsByUserIdAndCourseIdApiArg = {
  /** page */
  page?: number;
  /** size */
  size?: number;
  /** user uuid */
  id: string;
  /** course uuid */
  courseId: string;
};
export type EntityLessonContentType =
  | "lct-theory"
  | "lct-experiment"
  | "lct-reminder"
  | "lct-scale";
export type CookieResponse = {
  domain?: string;
  httpOnly?: boolean;
  maxAge?: number;
  name?: string;
  path?: string;
  secure?: boolean;
  value?: string;
};
export type AudioResponse = {
  cookies?: CookieResponse[];
  url?: string;
};
export type AudioMediaResponse = {
  content?: AudioResponse;
  id?: string;
};
export type ImageResponse = {
  type?: string;
  url?: string;
};
export type ImageMediaResponse = {
  content?: ImageResponse[];
  id?: string;
};
export type EntityMediaType = "image" | "video" | "audio";
export type VideoResponse = {
  cookies?: CookieResponse[];
  thumbnail?: ImageResponse[];
  url?: string;
};
export type VideoMediaResponse = {
  content?: VideoResponse;
  id?: string;
};
export type EntityMedia = {
  audio?: AudioMediaResponse;
  createdAt?: string;
  id?: string;
  image?: ImageMediaResponse;
  key?: string;
  type?: EntityMediaType;
  updatedAt?: string;
  video?: VideoMediaResponse;
};
export type EntityLessonContentStatus =
  | "lcs-active"
  | "lcs-preview"
  | "lcs-draft";
export type EntityLanguage = "en" | "de" | "de";
export type EntityLessonContentTranslation = {
  id?: string;
  language?: EntityLanguage;
  name?: string;
  noteMetaData?: string;
  scaleMetaData?: string;
  text?: string;
};
export type EntityLessonContent = {
  createdAt?: string;
  id?: string;
  lessonContentType?: EntityLessonContentType;
  media?: EntityMedia;
  order?: number;
  status?: EntityLessonContentStatus;
  translations?: EntityLessonContentTranslation[];
  updatedAt?: string;
};
export type EntityLessonStatus = "ls-active" | "ls-preview" | "ls-draft";
export type EntityLessonTranslation = {
  id?: string;
  language?: EntityLanguage;
  name?: string;
  text?: string;
};
export type EntityLesson = {
  contents?: EntityLessonContent[];
  createdAt?: string;
  id?: string;
  isFree?: boolean;
  order?: number;
  status?: EntityLessonStatus;
  titleImage?: EntityMedia;
  translations?: EntityLessonTranslation[];
  updatedAt?: string;
};
export type EntityRole =
  | "rs-user"
  | "rs-admin"
  | "rs-system-admin"
  | "rs-tester";
export type EntityUserStatus =
  | "us-new"
  | "us-pending"
  | "us-active"
  | "us-deactivated"
  | "us-deleted";
export type EntityProductType = "pt-subscription" | "pt-credits";
export type EntityProduct = {
  createdAt?: string;
  description?: string;
  /** Product id of Google Play Store */
  googleVendorProductID?: string;
  id?: string;
  priceLevel?: number;
  /** The product can be a subscription or a one-time credit purchase. */
  type?: EntityProductType;
  updatedAt?: string;
  /** Product id of Apple App Store */
  vendorProductID?: string;
};
export type EntitySubscriptionPackage = {
  createdAt?: string;
  /** Credits included in the subscription package */
  credits?: number;
  description?: string;
  /** Duration in days/months, only informative, true duration is defined by the plan on Apple/Google */
  duration?: number;
  id?: string;
  name?: string;
  plan?: "sp-basic" | "sp-premium";
  product?: EntityProduct;
  status?: "sps-active" | "sps-inactive";
  updatedAt?: string;
};
export type EntitySubscription = {
  cancelledAt?: string;
  createdAt?: string;
  endsAt?: string;
  id?: string;
  startsAt?: string;
  status?: "ss-active" | "ss-canceled" | "ss-expired";
  subscriptionPackage?: EntitySubscriptionPackage;
  updatedAt?: string;
  vendor?: "sv-google" | "sv-apple";
};
export type EntityUserOrigin =
  | "uo-facebook"
  | "uo-google"
  | "uo-apple"
  | "uo-internal";
export type EntityUser = {
  /** BlockedFeatures lists feature keys that are disabled for this user (e.g. chat, payments). */
  blockedFeatures?: string[];
  createdAt?: string;
  credits?: number;
  email: string;
  id?: string;
  image?: EntityMedia;
  language?: EntityLanguage;
  name?: string;
  role?: EntityRole;
  sendNotifications?: boolean;
  status?: EntityUserStatus;
  subscription?: EntitySubscription;
  timezone?: string;
  updatedAt?: string;
  userOrigin?: EntityUserOrigin;
};
export type EntityUserLesson = {
  createdAt?: string;
  doneAt?: string;
  id?: string;
  isDone?: boolean;
  lesson?: EntityLesson;
  updatedAt?: string;
  user?: EntityUser;
};
export type BackOfficeUserLessonPage = {
  count?: number;
  items?: EntityUserLesson[];
  last?: boolean;
  page?: number;
  size?: number;
};
export type ValidationError = {
  field?: string;
  message?: string;
};
export type ErrorResponse400 = {
  code?: number;
  data?: ValidationError[];
  message?: string;
};
export type ErrorResponse404 = {
  code?: number;
  data?: {
    [key: string]: string;
  }[];
  message?: string;
};
export const { useGetUserLessonsByUserIdAndCourseIdQuery } = injectedRtkApi;
